// Schedules.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import moment from 'moment';
import config from '../config';

import i18n from "../i18n";
const tr = i18n.t.bind(i18n);
const Schedules = ({ closeModal }) => {

  const [slots, setSlots] = useState([]);
  const [editingSlots, setEditingSlots] = useState([]);
  const [categories, setCategories] = useState([]);
  const [changes, setChanges] = useState(false);
  const [areas, setAreas] = useState([]);

  useEffect(() => {
    // Fetch schedules
    axios.get(tr('{{API_BASE_URL}}/schedules', {
      API_BASE_URL: config.API_BASE_URL
    }))
      .then(res => {
        setSlots(res.data);
        setEditingSlots(res.data.map(slot => ({
          id: slot.id,
          role: slot.role,
          day: slot.day,
          area: slot.area,
          starts: slot.starts,
          ends: slot.ends
        })));
      });

    // Fetch user roles dynamically
    axios.get(tr('{{API_BASE_URL}}/users/roles', {
      API_BASE_URL: config.API_BASE_URL
    }))
      .then(res => {
      const roles = res.data.map(role => ({
        id: role.id,
        name: role.name,
        role: role.id,
        area: null
      }));

      // Fetch areas dynamically
      axios.get(tr('{{API_BASE_URL}}/areas', {
        API_BASE_URL: config.API_BASE_URL
      }))
        .then(res => {
          setAreas(res.data);
          setCategories(prevCategories => [
            ...roles,
            ...res.data.map(area => ({
              id: area.id,
              name: area.name,
              role: 'at_service',
              area: area.id
            }))
          ]);
        });
    });
  }, []);

  const handleAddSlot = (role, day, areaId = null) => {
    const existingSlots = editingSlots.filter(slot => slot.area === areaId && slot.role === role && slot.day === day);
    const starts = existingSlots.length ? existingSlots[existingSlots.length - 1].ends : '10:00';
    const ends = moment(starts, 'HH:mm').add(8, 'hours').format('HH:mm');
    setEditingSlots([...editingSlots, { role, day, area: areaId, starts, ends }]);
    setChanges(true);
  };

  const handleSaveAll = async () => {
    const res = await axios.post(tr('{{API_BASE_URL}}/schedules/bulk', {
      API_BASE_URL: config.API_BASE_URL
    }), editingSlots);
    setSlots([...slots, ...res.data.newSlots]);
    setChanges(false);
  };

  const handleDeleteSlot = async (index) => {
    const slotToDelete = editingSlots[index];
    if (slotToDelete.id) {
      await axios.delete(tr('{{API_BASE_URL}}/schedules/{{id}}', {
        API_BASE_URL: config.API_BASE_URL,
        id: slotToDelete.id
      }));
    }
    setEditingSlots(editingSlots.filter((_, i) => i !== index));
  };

  const handleDeleteAllSlots = async () => {
    if(window.confirm('You want to clear all slots from schedule?')){
      const deleteRequests = editingSlots
        .filter(slot => slot.id)
        .map(slot => {
        return axios.delete(tr('{{API_BASE_URL}}/schedules/{{id}}', {
          API_BASE_URL: config.API_BASE_URL,
          id: slot.id
        }));
      });
      await Promise.all(deleteRequests);
      setEditingSlots([]);
    }
  };

  return (
    <div className="modal-overlay" style={{
      position: 'fixed',
      top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.6)',
      display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999
    }}>
      <div className="modal-content" style={{ background: 'white', padding: '20px', borderRadius: '8px', position: 'relative' }}>
        <h2>{tr('Manage Weekly Schedule Slots')}<button style={{padding: '5px', float: 'right', color: changes?'darkRed':'darkBlue'}} 
            onClick={()=>{
            if(changes){
              if(window.confirm('You have unsaved changes. Do you want to cancel them and close window?'))
              closeModal();
            }else{
              closeModal();
            }}}>
            {changes?'Cancel & ':''}{tr('Close')}</button>
        </h2>
        <table border="1" style={{ width: '100%', zoom: '85%' }}>
          <thead>
            <tr>
              <th>{tr('Role / Area')}</th>
              {[...Array(7)].map((_, i) => (
                <th key={i}> {moment().day(i + 1).format('dddd')} </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {categories.map((category, idx) => (
              <tr key={idx}>
                <th> {category.name} </th>
                {[...Array(7)].map((_, day) => {

                  return (
                    <td key={day} style={{verticalAlign: 'top', minWidth: '100px'}}>
                      {/* old logic:
                        editingSlots.map((slot, index) => (
                          slot.area === category.area && slot.role === category.id && slot.day === day ? (
                      */}
                      {editingSlots.map((slot, index) => {
                        return ((slot.day === day) &&
                        (
                          (category.area != null && slot.area === category.area) ||
                          (category.area == null && slot.area == null && slot.role === category.id)
                        ) ? (<div key={index}>
                          <button style={{color: 'red', cursor: 'pointer'}} title={tr('Remove Slot')} onClick={() => handleDeleteSlot(index)}>{tr('x')}</button>
                          <input
                            type="time"
                            value={slot.starts}
                            style={{margin: '0 2px 0 3px'}}
                            onChange={(e) => {
                              const updatedSlots = [...editingSlots]; 
                              updatedSlots[index].starts = e.target.value;
                              setEditingSlots(updatedSlots);
                              setChanges(true);
                            }}
                          />
                          <input
                            type="time"
                            value={slot.ends}
                            onChange={(e) => {
                              const updatedSlots = [...editingSlots];
                              updatedSlots[index].ends = e.target.value;
                              setEditingSlots(updatedSlots);
                              setChanges(true);
                            }}
                          />
                        </div>) : null);
                      })}
                      <button style={{color: 'green', cursor: 'pointer'}} title={tr('Add Slot')} onClick={() => handleAddSlot(category.id, day, category.area)}>+</button>
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
        <button onClick={handleDeleteAllSlots} disabled={editingSlots.length === 0} style={{padding: '5px', marginTop: '15px', float: 'left', background: 'darkRed', color: 'white', border: '1px solid darkGray', boxShadow: '1px 1px 2px gray', borderRadius: '4px', fontWeight: 'bold'}}>{tr('Delete All')}</button>
        <button onClick={handleSaveAll} disabled={!changes || editingSlots.length === 0} style={{padding: '5px', marginTop: '15px', float: 'right', background: changes?'darkGreen':'darkGray', color: 'white', border: '1px solid darkGray', boxShadow: '1px 1px 2px gray', borderRadius: '4px', fontWeight: 'bold'}}>{tr('Save All')}</button>
      </div>
    </div>
  );
};

export default Schedules;
